export default "/images/af0d046101de2d6972168a763d3b478c.avif";